export const initGlobalDateProps = () => {
    return true;
}

interface MethodInfo {
    methodName: string,
    description: string,
    group: string,
}

declare global {
    interface Date {
        toLocalISOString(): string;
        getWeekDay(): number;
    }
    interface DateConstructor {
        dateFromNowLocal(delta: number, deltaType: "day" | "week" | "month" | "year"): string;// в это же время относительно сегодня на delta deltaType
        dateFromTodayLocal(delta: number, deltaType: "day" | "week" | "month" | "year"): string;// в полночь (00:00:00) относительно сегодня на delta deltaType

        nowLocal(): string;//сейчас
        todayLocal(): string;// сегодня в полночь (00:00:00)

        tomorrowLocal(): string;// завтра в полночь (00:00:00)
        tomorrowAtThisTimeLocal(): string;// завтра в это же время
        dayAfterTomorrowLocal(): string;// послезавтра в полночь (00:00:00)
        dayAfterTomorrowAtThisTimeLocal(): string;// послезавтра в это же время
        yesterdayLocal(): string;// вчера в полночь (00:00:00)
        yesterdayAtThisTimeLocal(): string;// вчера в это же время
        dayBeforeYesterdayLocal(): string;// позавчера в полночь (00:00:00)
        dayBeforeYesterdayAtThisTimeLocal(): string;// позавчера в это же время

        oneDayAgoLocal(): string;// день назад в полночь (00:00:00). cиноним вчера
        oneDayAgoAtThisTimeLocal(): string;// день назад в это же время. cиноним вчера в тоже время
        twoDayAgoLocal(): string;// 2 дня назад в полночь (00:00:00). cиноним позавчера
        twoDayAgoAtThisTimeLocal(): string;// 2 дня назад в это же время. cиноним позавчера в тоже время
        threeDayAgoLocal(): string;// 3 дня назад в полночь (00:00:00)
        threeDayAgoAtThisTimeLocal(): string;// 3 дня назад в это же время
        fourDayAgoLocal(): string;// 4 дня назад в полночь (00:00:00)
        fourDayAgoAtThisTimeLocal(): string;// 4 дня назад в это же время

        oneWeekAgoLocal(): string;// неделю назад в полночь (00:00:00)
        oneWeekAgoAtThisTimeLocal(): string;// неделю назад в это же время 
        twoWeekAgoLocal(): string;// 2 недели назад в полночь (00:00:00)
        twoWeekAgoAtThisTimeLocal(): string;// 2 недели назад в это же время
        threeWeekAgoLocal(): string;// 3 недели назад в полночь (00:00:00)
        threeWeekAgoAtThisTimeLocal(): string;// 3 недели назад в это же время
        fourWeekAgoLocal(): string;// 4 недели назад в полночь (00:00:00)
        fourWeekAgoAtThisTimeLocal(): string;// 4 недели назад в это же время

        oneMonthAgoLocal(): string;// 1 месяц назад в полночь (00:00:00)
        oneMonthAgoAtThisTimeLocal(): string;// 1 месяц назад в это же время
        twoMonthAgoLocal(): string;// 2 месяца назад в полночь (00:00:00)
        twoMonthAgoAtThisTimeLocal(): string;// 2 месяца назад в это же время
        threeMonthAgoLocal(): string;// 3 месяца назад в полночь (00:00:00)
        threeMonthAgoAtThisTimeLocal(): string;// 3 месяца назад в это же время
        fourMonthAgoLocal(): string;// 4 месяца назад в полночь (00:00:00)
        fourMonthAgoAtThisTimeLocal(): string;// 4 месяца назад в это же время
        fiveMonthAgoLocal(): string;// 5 месяцев назад в полночь (00:00:00)
        fiveMonthAgoAtThisTimeLocal(): string;// 5 месяцев назад в это же время
        sixMonthAgoLocal(): string;// 6 месяцев назад в полночь (00:00:00)
        sixMonthAgoAtThisTimeLocal(): string;// 6 месяцев назад в это же время

        oneYearAgoLocal(): string;// 1 год назад в полночь (00:00:00)
        oneYearAgoAtThisTimeLocal(): string;// 1 год назад в это же время
        twoYearAgoLocal(): string;// 2 года назад в полночь (00:00:00)
        twoYearAgoAtThisTimeLocal(): string;// 2 года назад в это же время
        threeYearAgoLocal(): string;// 3 года назад в полночь (00:00:00)
        threeYearAgoAtThisTimeLocal(): string;// 3 года назад в это же время

        firstDayCurrWeekLocal(): string;// первый день текущей недели в полночь (00:00:00)
        firstDayCurrMonthLocal(): string;// первый день текущего месяца в полночь (00:00:00)
        firstDayCurrYearLocal(): string;// первый день текущего года в полночь (00:00:00)
        firstDayPrevWeekLocal(): string;// первый день предыдущей недели в полночь (00:00:00)
        firstDayPrevMonthLocal(): string;// первый день предыдущего месяца в полночь (00:00:00)
        firstDayPrevYearLocal(): string;// первый день предыдущего года в полночь (00:00:00)
        firstDayNextWeekLocal(): string;// первый день следующей недели в полночь (00:00:00)
        firstDayNextMonthLocal(): string;// первый день следующего месяца в полночь (00:00:00)
        firstDayNextYearLocal(): string;// первый день следующего года в полночь (00:00:00)

        lastDayCurrWeekLocal(): string;// последний день текущей недели в полночь (00:00:00)
        lastDayCurrMonthLocal(): string;// последний день текущего месяца в полночь (00:00:00)
        lastDayCurrYearLocal(): string;// последний день текущего года в полночь (00:00:00)
        lastDayPrevWeekLocal(): string;// последний день предыдущей недели в полночь (00:00:00)
        lastDayPrevMonthLocal(): string;// последний день предыдущего месяца в полночь (00:00:00)
        lastDayPrevYearLocal(): string;// последний день предыдущего года в полночь (00:00:00)
        lastDayNextWeekLocal(): string;// последний день следующей недели в полночь (00:00:00)
        lastDayNextMonthLocal(): string;// последний день следующего месяца в полночь (00:00:00)
        lastDayNextYearLocal(): string;// последний день следующего года в полночь (00:00:00)

        firstDayCurrQuarterLocal(): string;// первый день текущего квартала в полночь (00:00:00)
        lastDayCurrQuarterLocal(): string;// последний день текущего квартала в полночь (00:00:00)
        firstDayPrevQuarterLocal(): string;// первый день предыдущего квартала в полночь (00:00:00)
        lastDayPrevQuarterLocal(): string;// последний день предыдущего квартала в полночь (00:00:00)
        firstDayNextQuarterLocal(): string;// первый день следующего квартала в полночь (00:00:00)
        lastDayNextQuarterLocal(): string;// последний день следующего квартала в полночь (00:00:00)

        firstDayFirstQuarterCurrYearLocal(): string;// первый день 1-го квартала текущего года в полночь (00:00:00)
        lastDayFirstQuarterCurrYearLocal(): string;// последний день 1-го квартала текущего года в полночь (00:00:00)
        firstDaySecondQuarterCurrYearLocal(): string;// первый день 2-го квартала текущего года в полночь (00:00:00)
        lastDaySecondQuarterCurrYearLocal(): string;// последний день 2-го квартала текущего года в полночь (00:00:00)
        firstDayThirdQuarterCurrYearLocal(): string;// первый день 3-го квартала текущего года в полночь (00:00:00)
        lastDayThirdQuarterCurrYearLocal(): string;// последний день 3-го квартала текущего года в полночь (00:00:00)
        firstDayFourthQuarterCurrYearLocal(): string;// первый день 4-го квартала текущего года в полночь (00:00:00)
        lastDayFourthQuarterCurrYearLocal(): string;// последний день 4-го квартала текущего года в полночь (00:00:00)

        firstDayFirstQuarterPrevYearLocal(): string;// первый день 1-го квартала предыдущего года в полночь (00:00:00)
        lastDayFirstQuarterPrevYearLocal(): string;// последний день 1-го квартала предыдущего года в полночь (00:00:00)
        firstDaySecondQuarterPrevYearLocal(): string;// первый день 2-го квартала предыдущего года в полночь (00:00:00)
        lastDaySecondQuarterPrevYearLocal(): string;// последний день 2-го квартала предыдущего года в полночь (00:00:00)
        firstDayThirdQuarterPrevYearLocal(): string;// первый день 3-го квартала предыдущего года в полночь (00:00:00)
        lastDayThirdQuarterPrevYearLocal(): string;// последний день 3-го квартала предыдущего года в полночь (00:00:00)
        firstDayFourthQuarterPrevYearLocal(): string;// первый день 4-го квартала предыдущего года в полночь (00:00:00)
        lastDayFourthQuarterPrevYearLocal(): string;// последний день 4-го квартала предыдущего года в полночь (00:00:00)
        getMethodsWithDescription(type:"date"|"datetime"|any): MethodInfo[];
    }
}

Date.prototype.toLocalISOString = function () {
    let timeZoneOffsetMs = this.getTimezoneOffset() * 60000;
    let localTimeMs = this - timeZoneOffsetMs;
    let date = new Date(localTimeMs);
    let res = date.toISOString().replace('Z', '');
    return res;
};

Date.prototype.getWeekDay = function () {
    let weekDay = this.getDay();
    if (weekDay == 0) {
        weekDay = 7;
    }
    return weekDay;
};



const dateFromNowLocal = function (delta: number, deltaType: "day" | "week" | "month" | "year", withTime: boolean): string// в это же время относительно сегодня на delta deltaType
{
    delta = Math.trunc(delta);
    let date = new Date();
    if (deltaType == "day") {
        date.setDate(date.getDate() + delta);
    }
    else if (deltaType == "week") {
        date.setDate(date.getDate() + delta * 7);
    }
    else if (deltaType == "month") {
        date.setMonth(date.getMonth() + delta);
    }
    else if (deltaType == "year") {
        date.setFullYear(date.getFullYear() + delta);
    }
    if (!withTime) {
        date.setHours(0, 0, 0, 0);
    }
    return date.toLocalISOString();
}

Date.dateFromNowLocal = function (delta: number, deltaType: "day" | "week" | "month" | "year"): string// 
{
    return dateFromNowLocal(delta, deltaType, true);
}

Date.dateFromTodayLocal = function (delta: number, deltaType: "day" | "week" | "month" | "year"): string//
{
    return dateFromNowLocal(delta, deltaType, false);
}

const translateMsg = (msg: string, defaultValue: string) => {
//    if (msg == "nowLocal") return "Сейчас";
    //Тут локализация
    return defaultValue;
}

const cDescription = "description";
const cGroup = "group";
const cGroupDays = "Дни";
const cGroupWeeks = "Недели";
const cGroupWeekDays = "Дни недели";
const cGroupMonths = "Месяцы";
const cGroupMonthDays = "Дни месяца";
const cGroupYears = "Годы";
const cGroupYearDays = "Дни года";
const cGroupQuarters = "Кварталы";
const cGroupQuarterDays = "Дни квартала";

const setDateMethodDescription = (methodName: string, description: string, group: string) => {
    Date[methodName][cDescription] = translateMsg(methodName, description);
    Date[methodName][cGroup] = translateMsg(methodName, group);
}

Date.nowLocal = function () {
    return Date.dateFromNowLocal(0, "day");
};
setDateMethodDescription("nowLocal", "Сейчас", cGroupDays);

Date.todayLocal = function () {
    return Date.dateFromTodayLocal(0, "day");
};
setDateMethodDescription("todayLocal", "Сегодня", cGroupDays);

// завтра в полночь (00:00:00)
Date.tomorrowLocal = function () {
    return Date.dateFromTodayLocal(1, "day");
};
setDateMethodDescription("tomorrowLocal", "Завтра", cGroupDays);

// завтра в это же время
Date.tomorrowAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(1, "day");
};
setDateMethodDescription("tomorrowAtThisTimeLocal", "Завтра в это время", cGroupDays);

// послезавтра в полночь (00:00:00)
Date.dayAfterTomorrowLocal = function () {
    return Date.dateFromTodayLocal(2, "day");
};
setDateMethodDescription("dayAfterTomorrowLocal", "Послезавтра", cGroupDays);

// послезавтра в это же время
Date.dayAfterTomorrowAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(2, "day");
};
setDateMethodDescription("dayAfterTomorrowAtThisTimeLocal", "Послезавтра в это время", cGroupDays);

// вчера в полночь (00:00:00)
Date.yesterdayLocal = function () {
    return Date.dateFromTodayLocal(-1, "day");
};
setDateMethodDescription("yesterdayLocal", "Вчера", cGroupDays);

// вчера в это же время
Date.yesterdayAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-1, "day");
};
setDateMethodDescription("yesterdayAtThisTimeLocal", "Вчера в это время", cGroupDays);

// позавчера в полночь (00:00:00)
Date.dayBeforeYesterdayLocal = function () {
    return Date.dateFromTodayLocal(-2, "day");
};
setDateMethodDescription("dayBeforeYesterdayLocal", "Позавчера", cGroupDays);

// позавчера в это же время
Date.dayBeforeYesterdayAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-2, "day");
};
setDateMethodDescription("dayBeforeYesterdayAtThisTimeLocal", "Позавчера в это время", cGroupDays);

// день назад в полночь (00:00:00). cиноним вчера
Date.oneDayAgoLocal = function () {
    return Date.dateFromTodayLocal(-1, "day");
};
setDateMethodDescription("oneDayAgoLocal", "1 день назад", cGroupDays);

// день назад в это же время. cиноним вчера в тоже время
Date.oneDayAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-1, "day");
};
setDateMethodDescription("oneDayAgoAtThisTimeLocal", "1 день назад в это время", cGroupDays);

// 2 дня назад в полночь (00:00:00). cиноним позавчера
Date.twoDayAgoLocal = function () {
    return Date.dateFromTodayLocal(-2, "day");
};
setDateMethodDescription("twoDayAgoLocal", "2 дня назад", cGroupDays);
// 2 дня назад в это же время. cиноним позавчера в тоже время
Date.twoDayAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-2, "day");
};
setDateMethodDescription("twoDayAgoAtThisTimeLocal", "2 дня назад в это время", cGroupDays);

//  3 дня назад в полночь (00:00:00)
Date.threeDayAgoLocal = function () {
    return Date.dateFromTodayLocal(-3, "day");
};
setDateMethodDescription("threeDayAgoLocal", "3 дня назад", cGroupDays);
// 3 дня назад в это же время
Date.threeDayAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-3, "day");
};
setDateMethodDescription("threeDayAgoAtThisTimeLocal", "3 дня назад в это время", cGroupDays);

//  4 дня назад в полночь (00:00:00)
Date.fourDayAgoLocal = function () {
    return Date.dateFromTodayLocal(-4, "day");
};
setDateMethodDescription("fourDayAgoLocal", "4 дня назад", cGroupDays);
// 4 дня назад в это же время
Date.fourDayAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-4, "day");
};
setDateMethodDescription("fourDayAgoAtThisTimeLocal", "4 дня назад в это время", cGroupDays);

// неделю назад в полночь (00:00:00)
Date.oneWeekAgoLocal = function () {
    return Date.dateFromTodayLocal(-1, "week");
};
setDateMethodDescription("oneWeekAgoLocal", "1 неделю назад", cGroupWeeks);

// неделю назад в это же время
Date.oneWeekAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-1, "week");
};
setDateMethodDescription("oneWeekAgoAtThisTimeLocal", "1 неделю назад в это время", cGroupWeeks);

// 2 недели назад в полночь (00:00:00)
Date.twoWeekAgoLocal = function () {
    return Date.dateFromTodayLocal(-2, "week");
};
setDateMethodDescription("twoWeekAgoLocal", "2 недели назад", cGroupWeeks);
// 2 недели назад в это же время
Date.twoWeekAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-2, "week");
};
setDateMethodDescription("twoWeekAgoAtThisTimeLocal", "2 недели назад в это время", cGroupWeeks);

// 3 недели назад в полночь (00:00:00)
Date.threeWeekAgoLocal = function () {
    return Date.dateFromTodayLocal(-3, "week");
};
setDateMethodDescription("threeWeekAgoLocal", "3 недели назад", cGroupWeeks);
// 3 недели назад в это же время
Date.threeWeekAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-3, "week");
};
setDateMethodDescription("threeWeekAgoAtThisTimeLocal", "3 недели назад в это время", cGroupWeeks);

// 4 недели назад в полночь (00:00:00)
Date.fourWeekAgoLocal = function () {
    return Date.dateFromTodayLocal(-4, "week");
};
setDateMethodDescription("fourWeekAgoLocal", "4 недели назад", cGroupWeeks);
// 4 недели назад в это же время
Date.fourWeekAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-4, "week");
};
setDateMethodDescription("fourWeekAgoAtThisTimeLocal", "4 недели назад в это время", cGroupWeeks);

// 1 месяц назад в полночь (00:00:00)
Date.oneMonthAgoLocal = function () {
    return Date.dateFromTodayLocal(-1, "month");
};
setDateMethodDescription("oneMonthAgoLocal", "1 месяц назад", cGroupMonths);
// 1 месяц назад в это же время
Date.oneMonthAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-1, "month");
};
setDateMethodDescription("oneMonthAgoAtThisTimeLocal", "1 месяц назад в это время", cGroupMonths);

// 2 месяца назад в полночь (00:00:00)
Date.twoMonthAgoLocal = function () {
    return Date.dateFromTodayLocal(-2, "month");
};
setDateMethodDescription("twoMonthAgoLocal", "2 месяца назад", cGroupMonths);
// 2 месяца назад в это же время
Date.twoMonthAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-2, "month");
};
setDateMethodDescription("twoMonthAgoAtThisTimeLocal", "2 месяца назад в это время", cGroupMonths);

// 3 месяца назад в полночь (00:00:00)
Date.threeMonthAgoLocal = function () {
    return Date.dateFromTodayLocal(-3, "month");
};
setDateMethodDescription("threeMonthAgoLocal", "3 месяца назад", cGroupMonths);
// 3 месяца назад в это же время
Date.threeMonthAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-3, "month");
};
setDateMethodDescription("threeMonthAgoAtThisTimeLocal", "3 месяца назад в это время", cGroupMonths);

// 4 месяца назад в полночь (00:00:00)
Date.fourMonthAgoLocal = function () {
    return Date.dateFromTodayLocal(-4, "month");
};
setDateMethodDescription("fourMonthAgoLocal", "4 месяца назад", cGroupMonths);
// 4 месяца назад в это же время
Date.fourMonthAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-4, "month");
};
setDateMethodDescription("fourMonthAgoAtThisTimeLocal", "4 месяца назад в это время", cGroupMonths);

// 5 месяцев назад в полночь (00:00:00)
Date.fiveMonthAgoLocal = function () {
    return Date.dateFromTodayLocal(-5, "month");
};
setDateMethodDescription("fiveMonthAgoLocal", "5 месяцев назад", cGroupMonths);
// 5 месяцев назад в это же время
Date.fiveMonthAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-5, "month");
};
setDateMethodDescription("fiveMonthAgoAtThisTimeLocal", "5 месяцев назад в это время", cGroupMonths);

// 6 месяцев назад в полночь (00:00:00)
Date.sixMonthAgoLocal = function () {
    return Date.dateFromTodayLocal(-6, "month");
};
setDateMethodDescription("sixMonthAgoLocal", "6 месяцев назад", cGroupMonths);
// 6 месяцев назад в это же время
Date.sixMonthAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-6, "month");
};
setDateMethodDescription("sixMonthAgoAtThisTimeLocal", "6 месяцев назад в это время", cGroupMonths);

// 1 год назад в полночь (00:00:00)
Date.oneYearAgoLocal = function () {
    return Date.dateFromTodayLocal(-1, "year");
};
setDateMethodDescription("oneYearAgoLocal", "1 год назад", cGroupYears);
// 1 год назад в это же время
Date.oneYearAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-1, "year");
};
setDateMethodDescription("oneYearAgoAtThisTimeLocal", "1 год назад в это время", cGroupYears);

// 2 года назад в полночь (00:00:00)
Date.twoYearAgoLocal = function () {
    return Date.dateFromTodayLocal(-2, "year");
};
setDateMethodDescription("twoYearAgoLocal", "2 года назад", cGroupYears);
// 2 года назад в это же время
Date.twoYearAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-2, "year");
};
setDateMethodDescription("twoYearAgoAtThisTimeLocal", "2 года назад в это время", cGroupYears);

// 3 года назад в полночь (00:00:00)
Date.threeYearAgoLocal = function () {
    return Date.dateFromTodayLocal(-3, "year");
};
setDateMethodDescription("threeYearAgoLocal", "3 года назад", cGroupYears);
// 3 года назад в это же время
Date.threeYearAgoAtThisTimeLocal = function () {
    return Date.dateFromNowLocal(-3, "year");
};
setDateMethodDescription("threeYearAgoAtThisTimeLocal", "3 года назад в это время", cGroupYears);

// первый день текущей недели в полночь (00:00:00)
Date.firstDayCurrWeekLocal = function () {
    let date = new Date();
    date.setDate(date.getDate() - date.getWeekDay() + 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayCurrWeekLocal", "Понедельник текущей недели", cGroupWeekDays);

// первый день предыдущей недели в полночь (00:00:00)
Date.firstDayPrevWeekLocal = function () {
    let date = new Date();
    date.setDate(date.getDate() - date.getWeekDay() - 6);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayPrevWeekLocal", "Понедельник предыдущей недели", cGroupWeekDays);
// первый день следующей недели в полночь (00:00:00)
Date.firstDayNextWeekLocal = function () {
    let date = new Date();
    date.setDate(date.getDate() - date.getWeekDay() + 8);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayNextWeekLocal", "Понедельник следующей недели", cGroupWeekDays);

// последний день текущей недели в полночь (00:00:00)
Date.lastDayCurrWeekLocal = function () {
    let date = new Date();
    date.setDate(date.getDate() - date.getWeekDay() + 7);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayCurrWeekLocal", "Воскресенье текущей недели", cGroupWeekDays);

// последний день предыдущей недели в полночь (00:00:00)
Date.lastDayPrevWeekLocal = function () {
    let date = new Date();
    date.setDate(date.getDate() - date.getWeekDay());
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayPrevWeekLocal", "Воскресенье предыдущей недели", cGroupWeekDays);

// последний день следующей недели в полночь (00:00:00)
Date.lastDayNextWeekLocal = function () {
    let date = new Date();
    date.setDate(date.getDate() - date.getWeekDay() + 14);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayNextWeekLocal", "Воскресенье следуюшей недели", cGroupWeekDays);

// первый день текущего месяца в полночь (00:00:00)
Date.firstDayCurrMonthLocal = function () {
    let date = new Date();
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayCurrMonthLocal", "Первый день текущего месяца", cGroupMonthDays);

// последний день текущего месяца в полночь (00:00:00)
Date.lastDayCurrMonthLocal = function () {
    let date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() + 1);
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayCurrMonthLocal", "Последний день текущего месяца", cGroupMonthDays);

// первый день предыдущего месяца в полночь (00:00:00)
Date.firstDayPrevMonthLocal = function () {
    let date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayPrevMonthLocal", "Первый день предыдущего месяца", cGroupMonthDays);

// последний день предыдущего месяца в полночь (00:00:00)
Date.lastDayPrevMonthLocal = function () {
    let date = new Date();
    date.setDate(1);
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayPrevMonthLocal", "Последний день предыдущего месяца", cGroupMonthDays);

// первый день следующего месяца в полночь (00:00:00)
Date.firstDayNextMonthLocal = function () {
    let date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() + 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayNextMonthLocal", "Первый день следующего месяца", cGroupMonthDays);

// последний день следующего месяца в полночь (00:00:00)
Date.lastDayNextMonthLocal = function () {
    let date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() + 2);
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayNextMonthLocal", "Последний день следующего месяца", cGroupMonthDays);

// первый день текущего года в полночь(00: 00: 00)
Date.firstDayCurrYearLocal = function () {
    let date = new Date();
    date.setMonth(0);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayCurrYearLocal", "Первый день текущего года", cGroupYearDays);

// последний день текущего года в полночь (00:00:00)
Date.lastDayCurrYearLocal = function () {
    let date = new Date();
    date.setMonth(12);
    date.setDate(1);
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayCurrYearLocal", "Последний день текущего года", cGroupYearDays);

// первый день предыдущего года в полночь (00:00:00)
Date.firstDayPrevYearLocal = function () {
    let date = new Date();
    date.setMonth(0);
    date.setDate(1);
    date.setFullYear(date.getFullYear() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayPrevYearLocal", "Первый день предыдущего года", cGroupYearDays);

// последний день предыдущего года в полночь (00:00:00)
Date.lastDayPrevYearLocal = function () {
    let date = new Date();
    date.setMonth(0);
    date.setDate(1);
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayPrevYearLocal", "Последний день предыдущего года", cGroupYearDays);

// первый день следующего года в полночь (00:00:00)
Date.firstDayNextYearLocal = function () {
    let date = new Date();
    date.setMonth(0);
    date.setDate(1);
    date.setFullYear(date.getFullYear() + 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("firstDayNextYearLocal", "Первый день следующего года", cGroupYearDays);

// последний день следующего года в полночь (00:00:00)
Date.lastDayNextYearLocal = function () {
    let date = new Date();
    date.setMonth(0);
    date.setDate(1);
    date.setFullYear(date.getFullYear() + 2);
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
};
setDateMethodDescription("lastDayNextYearLocal", "Последний день следующего года", cGroupYearDays);

// первый день текущего квартала в полночь (00:00:00)
const getQuarterDay = (quarter0: number | "curr" | "prev" | "next", year0: number | "curr" | "prev" | "next", type:"first"|"last") => {
    //quarter : 0,1,2,3
    let date = new Date();
    let year;
    if (year0 == "curr") {
        year = date.getFullYear();
    }
    else if (year0 == "prev") {
        year = date.getFullYear() - 1;
    }
    else if (year0 == "next") {
        year = date.getFullYear() + 1;
    }
    else {
        year = year0;
    }

    let quarter;
    if (quarter0 == "curr") {
        quarter = Math.trunc(date.getMonth() / 3);
    }
    else if (quarter0 == "prev") {
        quarter = Math.trunc(date.getMonth() / 3) - 1;
        if (quarter < 0) {
            quarter = 3;
            year = year - 1;
        }
    }
    else if (quarter0 == "next") {
        quarter = Math.trunc(date.getMonth() / 3) + 1;
        if (quarter > 3) {
            quarter = 0;
            year = year + 1;
        }
    }
    else {
        quarter = quarter0;
    }

    date.setFullYear(year);
    date.setDate(1);
    date.setMonth((quarter + (type == "last" ? 1 : 0)) * 3);
    if (type == "last") {
        date.setDate(date.getDate() - 1);
    }
    date.setHours(0, 0, 0, 0);
    return date.toLocalISOString();
}

// первый день текущего квартала в полночь (00:00:00)
Date.firstDayCurrQuarterLocal = function () {
    return getQuarterDay("curr", "curr", "first");
};
setDateMethodDescription("firstDayCurrQuarterLocal", "Первый день текущего квартала", cGroupQuarterDays);

// последний день текущего квартала в полночь (00:00:00)
Date.lastDayCurrQuarterLocal = function () {
    return getQuarterDay("curr", "curr", "last");
};
setDateMethodDescription("lastDayCurrQuarterLocal", "Последний день текущего квартала", cGroupQuarterDays);

// первый день предыдущего квартала в полночь (00:00:00)
Date.firstDayPrevQuarterLocal = function () {
    return getQuarterDay("prev", "curr", "first");
};
setDateMethodDescription("firstDayPrevQuarterLocal", "Первый день предыдущего квартала", cGroupQuarterDays);
// последний день предыдущего квартала в полночь (00:00:00)
Date.lastDayPrevQuarterLocal = function () {
    return getQuarterDay("prev", "curr", "last");
};
setDateMethodDescription("lastDayPrevQuarterLocal", "Последний день предыдущего квартала", cGroupQuarterDays);

// первый день следующего квартала в полночь (00:00:00)
Date.firstDayNextQuarterLocal = function () {
    return getQuarterDay("next", "curr", "first");
};
setDateMethodDescription("firstDayNextQuarterLocal", "Первый день следующего квартала", cGroupQuarterDays);
// последний день следующего квартала в полночь (00:00:00)
Date.lastDayNextQuarterLocal = function () {
    return getQuarterDay("next", "curr", "last");
};
setDateMethodDescription("lastDayNextQuarterLocal", "Последний день следующего квартала", cGroupQuarterDays);

// первый день 1-го квартала текущего года в полночь (00:00:00)
Date.firstDayFirstQuarterCurrYearLocal = function () {
    return getQuarterDay(0, "curr", "first");
};
setDateMethodDescription("firstDayFirstQuarterCurrYearLocal", "Первый день 1-го квартала текущего года", cGroupQuarterDays);
// последний день 1-го квартала текущего года в полночь (00:00:00)
Date.lastDayFirstQuarterCurrYearLocal = function () {
    return getQuarterDay(0, "curr", "last");
};
setDateMethodDescription("lastDayFirstQuarterCurrYearLocal", "Последний день 1-го квартала текущего года", cGroupQuarterDays);
// первый день 2-го квартала текущего года в полночь (00:00:00)
Date.firstDaySecondQuarterCurrYearLocal = function () {
    return getQuarterDay(1, "curr", "first");
};
setDateMethodDescription("firstDaySecondQuarterCurrYearLocal", "Первый день 2-го квартала текущего года", cGroupQuarterDays);
// последний день 2-го квартала текущего года в полночь (00:00:00)
Date.lastDaySecondQuarterCurrYearLocal = function () {
    return getQuarterDay(1, "curr", "last");
};
setDateMethodDescription("lastDaySecondQuarterCurrYearLocal", "Последний день 2-го квартала текущего года", cGroupQuarterDays);

// первый день 3-го квартала текущего года в полночь (00:00:00)
Date.firstDayThirdQuarterCurrYearLocal = function () {
    return getQuarterDay(2, "curr", "first");
};
setDateMethodDescription("firstDayThirdQuarterCurrYearLocal", "Первый день 3-го квартала текущего года", cGroupQuarterDays);
// последний день 3-го квартала текущего года в полночь (00:00:00)
Date.lastDayThirdQuarterCurrYearLocal = function () {
    return getQuarterDay(2, "curr", "last");
};
setDateMethodDescription("lastDayThirdQuarterCurrYearLocal", "Последний день 3-го квартала текущего года", cGroupQuarterDays);

// первый день 4-го квартала текущего года в полночь (00:00:00)
Date.firstDayFourthQuarterCurrYearLocal = function () {
    return getQuarterDay(3, "curr", "first");
};
setDateMethodDescription("firstDayFourthQuarterCurrYearLocal", "Первый день 4-го квартала текущего года", cGroupQuarterDays);
// последний день 4-го квартала текущего года в полночь (00:00:00)
Date.lastDayFourthQuarterCurrYearLocal = function () {
    return getQuarterDay(3, "curr", "last");
};
setDateMethodDescription("lastDayFourthQuarterCurrYearLocal", "Последний день 4-го квартала текущего года", cGroupQuarterDays);

//////
// первый день 1-го квартала предыдущего года в полночь (00:00:00)
Date.firstDayFirstQuarterPrevYearLocal = function () {
    return getQuarterDay(0, "prev", "first");
};
setDateMethodDescription("firstDayFirstQuarterPrevYearLocal", "Первый день 1-го квартала предыдущего года", cGroupQuarterDays);

// последний день 1-го квартала предыдущего года в полночь (00:00:00)
Date.lastDayFirstQuarterPrevYearLocal = function () {
    return getQuarterDay(0, "prev", "last");
};
setDateMethodDescription("lastDayFirstQuarterPrevYearLocal", "Последний день 1-го квартала предыдущего года", cGroupQuarterDays);
// первый день 2-го квартала предыдущего года в полночь (00:00:00)
Date.firstDaySecondQuarterPrevYearLocal = function () {
    return getQuarterDay(1, "prev", "first");
};
setDateMethodDescription("firstDaySecondQuarterPrevYearLocal", "Первый день 2-го квартала предыдущего года", cGroupQuarterDays);
// последний день 2-го квартала предыдущего года в полночь (00:00:00)
Date.lastDaySecondQuarterPrevYearLocal = function () {
    return getQuarterDay(1, "prev", "last");
};
setDateMethodDescription("lastDaySecondQuarterPrevYearLocal", "Последний день 2-го квартала предыдущего года", cGroupQuarterDays);

// первый день 3-го квартала предыдущего года в полночь (00:00:00)
Date.firstDayThirdQuarterPrevYearLocal = function () {
    return getQuarterDay(2, "prev", "first");
};
setDateMethodDescription("firstDayThirdQuarterPrevYearLocal", "Первый день 3-го квартала предыдущего года", cGroupQuarterDays);
// последний день 3-го квартала предыдущего года в полночь (00:00:00)
Date.lastDayThirdQuarterPrevYearLocal = function () {
    return getQuarterDay(2, "prev", "last");
};
setDateMethodDescription("lastDayThirdQuarterPrevYearLocal", "Последний день 3-го квартала предыдущего года", cGroupQuarterDays);

// первый день 4-го квартала предыдущего года в полночь (00:00:00)
Date.firstDayFourthQuarterPrevYearLocal = function () {
    return getQuarterDay(3, "prev", "first");
};
setDateMethodDescription("firstDayFourthQuarterPrevYearLocal", "Первый день 4-го квартала предыдущего года", cGroupQuarterDays);

// последний день 4-го квартала предыдущего года в полночь (00:00:00)
Date.lastDayFourthQuarterPrevYearLocal = function () {
    return getQuarterDay(3, "prev", "last");
};
setDateMethodDescription("lastDayFourthQuarterPrevYearLocal", "Последний день 4-го квартала предыдущего года", cGroupQuarterDays);

Date.getMethodsWithDescription = function (type: "date" | "datetime" | any) {
    const cTimeSubstr = "AtThisTime";
    let result = [];
    for (var key in Date) {
        if (!Date[key][cDescription]) continue;
        if (type == "date") {
            if (key.includes(cTimeSubstr) || key == "nowLocal") {
                continue;
            }
        }
        const methodInfo: MethodInfo = {
            methodName: "Date."+key,
            description: Date[key][cDescription],
            group: Date[key][cGroup],
        }
        result.push(methodInfo);
    }
    return result;
}
